module.exports = __webpack_public_path__ + "img/pc_happy_feet.fbbe8197.png";